module.exports = __webpack_public_path__ + "img/stream.328ed0b5.svg";